import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

// ==========================================
// PRODUCTS APIs
// ==========================================

export const GetProducts = async (params: {
  page: number;
  limit: number;
  search?: string;
  category_id?: number | null;
  brand_id?: number | null;
  isPos?: boolean;
  store_id?: string | null;
  is_on_web?: boolean;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/products`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load products.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateProduct = async (
  formData: FormData,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/products/create`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create product.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "validation",
        errors: error?.response?.data?.errors,
      },
    };
  }
};

export const UpdateProduct = async (
  formData: FormData,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/products/update`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update product.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "validation",
        errors: error?.response?.data?.errors,
      },
    };
  }
};

export const ToggleProductStatus = async (
  id: number,
  status: "Active" | "Inactive",
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/products/status`, {
      id,
      status,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to change status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteProduct = async (id: number): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/products/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete product.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const ImportProducts = async (
  products: any[],
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/products/import`, { products });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to import products.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "validation",
        errors: error?.response?.data?.errors,
      },
    };
  }
};

export const ToggleProductPosStatus = async (
  id: number,
  is_pos: 0 | 1,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/products/toggle-pos`, {
      id,
      is_pos,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update POS status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const ToggleProductNegativeQtyStatus = async (
  id: number,
  is_negative_qty_allowed: 0 | 1,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/products/toggle-negative-qty`, {
      id,
      is_negative_qty_allowed,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to update negative quantity status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const ToggleProductIsOnWeb = async (
  id: number,
  is_on_web: 0 | 1,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/products/toggle-is-on-web`, {
      id,
      is_on_web,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update web status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const GetPosProducts = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/products/pos`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load POS products.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
